import { useMutation } from "@tanstack/react-query";

import {
  type FetchResponseOfError,
  postAuthRegisterPartner,
  type RegisterPartnerRequest,
} from "Infrastructure/Api/Api";
import { ApiCallError, isSuccessResponse } from "Infrastructure/Api/ApiUtils";

export function useRegisterPartnerMutation() {
  return useMutation({
    mutationFn: (request: RegisterPartnerRequest) =>
      postAuthRegisterPartner(request),
    onSuccess: (data) => {
      if (!isSuccessResponse(data)) {
        throw new ApiCallError(data as unknown as FetchResponseOfError);
      }
    },
  });
}
